export const getMenuPadding = (theme, isHeaderHidden, isWideDropdown) => {
  let padding = theme.spacing(1.5, 0, 1.5, 0);
  if (isHeaderHidden) padding = theme.spacing(1, 0, 1, 0);
  else if (isWideDropdown) padding = theme.spacing(1.5, 0, 0, 0);
  return padding;
};